// extracted by mini-css-extract-plugin
export var errorIcon = "_jn-1";
export var nameLogo = "_jn-0";